import { IAndIList } from "@/components/IAndI/IAndIList";
import { SummaryMetrics } from "@/components/IAndI/SummaryMetrics";

export const InfiltrationInflow = () => {
	return (
		<div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6 h-full overflow-hidden">
			<header className="flex items-center justify-between">
				<h1 className="text-2xl md:text-4xl font-semibold tracking-tight">Infiltration and Inflow</h1>
			</header>
			<SummaryMetrics />
			<IAndIList enableUrl enableFlow />
		</div>
	);
};
